import { t } from '@lingui/core/macro';
import { TIntroducerApplication } from 'lendingApi/applications.types';
import { APPLICATION_STATUS } from 'utils/applications/applications.config';

type TProgress = 'done' | 'pending' | 'current' | 'failed';

export type TProgressBarStep = {
  label: string;
  progress: TProgress;
};

export function getApplicationSteps(
  status: TIntroducerApplication['status'],
): TProgressBarStep[] {
  const APPLICATION_STEPS = () => [
    {
      step: 0,
      label: t`App created`,
      statuses: [APPLICATION_STATUS.open],
    },
    {
      step: 1,
      label: t`Docs required`,
      statuses: [
        APPLICATION_STATUS.manual_review,
        APPLICATION_STATUS.action_required,
      ],
    },
    {
      step: 2,
      label: t`App in review`,
      statuses: [
        APPLICATION_STATUS.awaiting_underwriter,
        APPLICATION_STATUS.in_underwriting,
        APPLICATION_STATUS.customer_to_link_open_banking,
      ],
    },
    {
      step: 3,
      label: t`App decision`,
      statuses: [
        APPLICATION_STATUS.deferred,
        APPLICATION_STATUS.declined,
        APPLICATION_STATUS.offer_rejected,
        APPLICATION_STATUS.offered,
        APPLICATION_STATUS.conditional_offer,
      ],
    },
    {
      step: 4,
      label: t`Funded`,
      statuses: [APPLICATION_STATUS.talking_to_customer],
    },
    {
      step: 5,
      label: t`Complete`,
      statuses: [APPLICATION_STATUS.funded],
    },
  ];

  const { step: currentStep } =
    APPLICATION_STEPS().find(({ statuses }) => statuses.includes(status)) || {};

  if (currentStep === undefined) {
    return [];
  }

  return APPLICATION_STEPS()
    .slice(0, -1)
    .map(({ label, step }) => {
      let progress: TProgress = 'pending';

      if (step < currentStep) {
        progress = 'done';
      } else if (step === currentStep) {
        if (
          [
            APPLICATION_STATUS.declined,
            APPLICATION_STATUS.deferred,
            APPLICATION_STATUS.offer_rejected,
          ].includes(status)
        ) {
          progress = 'failed';
        } else {
          progress = 'current';
        }
      }

      return { label, progress };
    });
}
